import React, { useState } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import { globalState } from 'helpers/store';
import { notify } from 'helpers/globalFunctions';
import { baseUrl, apiHelper } from 'helpers/util';
import ColumnBox from 'components/ColumnBox';
import SmallHeading from 'components/SmallHeading';

export default function PasswordProtect(props) {
    const [ isPasswordSubmitting, setIsPasswordSubmitting ] = useState(false);
    const [ enteredPassword, setEnteredPassword ] = useState(null);
    const [ isLocalPasswordCorrect, setIsLocalPasswordCorrect ] = useState(false);

    const submitPassword = function() {
        setIsPasswordSubmitting(true);
        
        // Check against the specific password for this component
        if (enteredPassword === props.password) {
            setIsLocalPasswordCorrect(true);
        } else {
            notify.error({ "description": "Invalid Password" });
        }
        setIsPasswordSubmitting(false);
    }


    if (!isLocalPasswordCorrect) {
        return (
        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',
            padding: '15px' }}>
            <ColumnBox sx={{ alignItems: 'center', maxWidth: '500px',
                width: '100%' }}>
                <SmallHeading>Enter password</SmallHeading>
                <TextField sx={{ marginTop: '10px' }}
                    size="small" onChange={ (e) => setEnteredPassword(e.target.value) }
                    label="Enter Password" />
                { isPasswordSubmitting ? <CircularProgress sx={{ marginTop: '10px' }} /> :
                    <Button sx={{ marginTop: '10px' }} onClick={ submitPassword }
                        variant="outlined">Submit</Button>
                }
            </ColumnBox>
        </Box>);
    } else {
        return (
            <>{ props.children }</>
        )
    }
}
